export { default } from './dist/vue-google-charts.common'
export * from './dist/vue-google-charts.common'
// import './dist/vue-google-charts.css'



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-google-charts@0.3.3/~/vue-google-charts/index.js
// module id = /yvT
// module chunks = 5